export const ROLE_HOME = {
  student: "/app/student",
  parent: "/app/parent",
  teacher: "/app/teacher",
  school_admin: "/app/school",
  platform_admin: "/app/admin",
};

export function homeForRole(role) {
  return ROLE_HOME[role] || "/";
}
